import Component from "../abstracts/Component";

import 'gsap';
import ScrollMagic from 'scrollmagic';
// import 'debug.addIndicators';
import 'animation.gsap'


export default class EditorialPushComponent extends Component {

  get SELECTORS() {
    return {
      main: '.c-editorial-push',
      parallaxPicture: 'picture',
    }
  }

  // constructor (){
  //   console.log('const this', this);
  // }

  AnimateParallax(el) {

    // attivo il parallasse solo se sono ad una risoluzione maggiore di 1023
    // if (Math.max(document.documentElement.clientWidth, window.innerWidth || 0) > 1023) {

      var offset = Math.max(document.documentElement.clientHeight, window.innerHeight || 0) + el.offsetHeight;
      var controller = new ScrollMagic.Controller({
        globalSceneOptions: {
          triggerHook: 1,
          duration: offset
        }
      });

      var parallaxDirection;
      var bodyWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
      if(bodyWidth > 1023){
        parallaxDirection = "+70%";
      }else{
        parallaxDirection = "+50%";
      }
      
      if (el.classList.contains('fullscreen-image')) {
        parallaxDirection = "0";
      }

      new ScrollMagic.Scene({
          triggerElement: el
        })
        .setTween(el.querySelector(this.SELECTORS.parallaxPicture), {
          y: parallaxDirection,
          ease: Linear.easeNone
        })
        // .addIndicators()
        .addTo(controller);
    // }

  }

  render() {

    var elements = document.querySelectorAll(this.SELECTORS.main);

    if (elements.length > 0) {
      elements.forEach(element => {
        this.AnimateParallax(element);
      });
    }
  }

}
